export default "__VITE_ASSET__3a001aec__"